/**
 * sophior-consent.js
 * Twee consent-taken, beide via Shopify's Customer Privacy API:
 *
 * 1. Cookievoorkeuren heropenen: een klik op [data-sophior-cookie-prefs]
 *    (footerknop) opent de Shopify-consentbanner opnieuw, zodat een
 *    bezoeker een eerdere keuze kan wijzigen of intrekken (AVG art. 7 lid 3).
 *
 * 2. Klaviyo onsite-JS consent-gated laden: klaviyo.js (kortingspopup +
 *    onsite tracking) wordt pas geinjecteerd zodra er marketing-toestemming
 *    is, ook wanneer die pas later in de sessie wordt gegeven. Dit vervangt
 *    de Klaviyo app embed (Thema > App embeds), die het script ongeacht de
 *    keuze laadde: zet die embed UIT zodra dit live staat. Zolang de embed
 *    nog aanstaat wordt dubbel laden gedetecteerd en overgeslagen.
 *    Het footer-nieuwsbriefformulier en back-in-stock lopen via de
 *    client-API (sophior-klaviyo-form.js) en zijn hier niet van afhankelijk.
 *    Beperking: een al geladen klaviyo.js kan bij intrekking niet worden
 *    teruggedraaid binnen dezelfde paginaweergave; vanaf de eerstvolgende
 *    navigatie wordt de nieuwe keuze gevolgd.
 */
(function () {
  var script = document.currentScript || document.querySelector('script[data-klaviyo-company]');
  var companyId = script && script.dataset ? script.dataset.klaviyoCompany : '';
  var klaviyoLoaded = false;

  function klaviyoAlreadyPresent() {
    return !!(
      window.klaviyo ||
      window._learnq ||
      document.querySelector('script[src*="static.klaviyo.com/onsite/js/klaviyo.js"]')
    );
  }

  function loadKlaviyo() {
    if (klaviyoLoaded || !companyId || klaviyoAlreadyPresent()) return;
    klaviyoLoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(companyId);
    document.head.appendChild(s);
  }

  function marketingAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return false;
    try {
      if (typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() === true;
    } catch (e) {
      /* API nog niet klaar: behandelen als geen toestemming */
    }
    return false;
  }

  function customerPrivacyReady() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && typeof cp.marketingAllowed === 'function');
  }

  function checkConsent() {
    if (marketingAllowed()) loadKlaviyo();
  }

  /* De Customer Privacy API verschijnt niet vanzelf: bij een terugkerende
     bezoeker met een opgeslagen keuze (banner niet meer in beeld) bleef
     window.Shopify.customerPrivacy undefined, de poll hieronder liep na 10 s
     leeg en Klaviyo (popup + onsite tracking) laadde nooit, ook niet met
     toestemming. Shopify's gedocumenteerde route is loadFeatures met de
     consent-tracking-api; daarna is marketingAllowed() direct beschikbaar.
     Geverifieerd 16 sep 2026 op het preview-thema (batch 3). */
  function requestCustomerPrivacyApi() {
    if (customerPrivacyReady()) {
      checkConsent();
      return;
    }
    if (!(window.Shopify && typeof window.Shopify.loadFeatures === 'function')) return;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) checkConsent();
      });
    } catch (e) {
      /* de poll hieronder vangt het alsnog op */
    }
  }
  requestCustomerPrivacyApi();

  /* Bezoeker geeft of wijzigt de keuze tijdens deze paginaweergave. Het
     event kan al vuren terwijl window.Shopify.customerPrivacy nog de stub
     zonder methoden is (zie de pollfunctie hieronder); daarom hier dezelfde
     "is de API echt klaar"-controle met een korte herhaling in plaats van
     één enkele aanroep. */
  document.addEventListener('visitorConsentCollected', function () {
    var handlerTries = 0;
    var handlerTimer = setInterval(function () {
      handlerTries += 1;
      if (customerPrivacyReady()) {
        clearInterval(handlerTimer);
        checkConsent();
      } else if (handlerTries >= 40) {
        clearInterval(handlerTimer);
      }
    }, 250);
  });

  /* Terugkerende bezoeker met opgeslagen toestemming: de Customer Privacy
     API laadt asynchroon. window.Shopify.customerPrivacy verschijnt eerst
     als stub ({cachedConsent, cachedToken, consentStatus}) zonder methoden;
     pas als marketingAllowed() er als functie op staat, is de API echt
     klaar. Stoppen op het kale bestaan van het object (zoals voorheen) gaf
     op de pagina waar de bezoeker toestemming geeft "is not a function",
     checkConsent() viel terug op "geen toestemming" en de poll kwam nooit
     meer terug: Klaviyo onsite-JS laadde dan pas op de volgende
     paginaweergave. Daarom hier doorpollen tot de functie er echt is. */
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (customerPrivacyReady()) {
      clearInterval(timer);
      checkConsent();
    } else if (tries >= 40) {
      clearInterval(timer);
    }
  }, 250);

  /* Cookievoorkeuren-knop: consentbanner heropenen. */
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target.closest('[data-sophior-cookie-prefs]') : null;
    if (!target) return;
    event.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.showPreferences === 'function') {
      cp.showPreferences();
    }
  });
})();

/* ---- Redesign golf 4 · consent v2 (s08-schil, D02 §3.14 en §5.3) ----
   Het stapelcontract van de onderbalken, alleen met header v2 (B6:
   html[data-sophior-header="v2"]) of met "Cookiebanner: knoppen gelijkwaardig"
   aan (body.sophior-uitrol--consent); anders doet dit blok niets.
   - html.sophior-consent-open zolang #shopify-pc__banner in beeld is;
   - --sophior-consent-h op html: de hoogte van de banner (één lezing per
     wijziging), zodat bijvoorbeeld "Bekijk alle resultaten" in de zoeklaag
     erboven blijft (bottom: var(--sophior-consent-h, 0px));
   - event sophior:consent-settled op document zodra de keuze is gemaakt of er
     geen banner komt (terugkerende bezoeker, na 3 s), één keer per pagina,
     detail { marketing, analytics } (true, false of null als de API nog niet
     klaar is).
   Geen cookies, geen meting: alleen een klasse, een custom property en een
   event. De strook van D04 en de duimbalk van D08 kunnen hierop aanhaken. */
(function () {
  var root = document.documentElement;
  var body = document.body;
  if (!body) return;
  var v2 = root.getAttribute('data-sophior-header') === 'v2';
  if (!v2 && !body.classList.contains('sophior-uitrol--consent')) return;
  if (window.__sophiorConsentContract) return;
  window.__sophiorConsentContract = true;

  var OPEN = 'sophior-consent-open';
  var open = false;
  var gemeld = false;
  var bannerMo = null;
  var gevolgd = null;

  function banner() {
    return document.getElementById('shopify-pc__banner');
  }

  function zichtbaar(b) {
    if (!b || b.hidden) return false;
    var cs = window.getComputedStyle(b);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    return b.getClientRects().length > 0;
  }

  function keuze() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    var uit = { marketing: null, analytics: null };
    if (!cp) return uit;
    try {
      if (typeof cp.marketingAllowed === 'function') uit.marketing = cp.marketingAllowed() === true;
      if (typeof cp.analyticsProcessingAllowed === 'function') uit.analytics = cp.analyticsProcessingAllowed() === true;
    } catch (e) {
      /* API nog niet klaar */
    }
    return uit;
  }

  function meld() {
    if (gemeld) return;
    gemeld = true;
    document.dispatchEvent(new CustomEvent('sophior:consent-settled', { detail: keuze() }));
  }

  function volg(b) {
    if (!b || b === gevolgd || !('MutationObserver' in window)) return;
    if (bannerMo) bannerMo.disconnect();
    gevolgd = b;
    bannerMo = new MutationObserver(werkBij);
    bannerMo.observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
  }

  function werkBij() {
    var b = banner();
    volg(b);
    var nu = zichtbaar(b);
    if (nu) {
      root.style.setProperty('--sophior-consent-h', b.offsetHeight + 'px');
    } else {
      root.style.removeProperty('--sophior-consent-h');
    }
    if (nu !== open) {
      open = nu;
      root.classList.toggle(OPEN, nu);
      if (!nu) meld();
    }
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (banner() !== gevolgd) werkBij();
    }).observe(body, { childList: true });
  }
  document.addEventListener('visitorConsentCollected', function () {
    window.setTimeout(function () {
      werkBij();
      if (!open) meld();
    }, 0);
  });
  window.addEventListener('resize', function () {
    if (open) werkBij();
  });
  werkBij();
  /* Terugkerende bezoeker met een opgeslagen keuze: geen banner na 3 s */
  window.setTimeout(function () {
    if (!open) meld();
  }, 3000);
})();
